var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"operating",on:{"click":function($event){$event.stopPropagation();return _vm.operate($event)}}},[_c('i',{class:['zmdi','fs16','zmdi-'+_vm.icon,'text-'+_vm.color]})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2622e11c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components-base/components-custom/operating-button/operating-button.vue
// module id = null
// module chunks = 